/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbSharedRefineMenuCaratWeight_itemSearch$ref = any;
export type SbRespRefineMenuFilterCaratWeight_itemSearch$ref = any;
export type SbRespRefineMenuFilterCaratWeight_itemSearch = {
    readonly " $fragmentRefs": SbSharedRefineMenuCaratWeight_itemSearch$ref;
    readonly " $refType": SbRespRefineMenuFilterCaratWeight_itemSearch$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespRefineMenuFilterCaratWeight_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuCaratWeight_itemSearch",
      "args": null
    }
  ]
};
(node as any).hash = 'e1a176908cb88e74c5bfbd6093c521da';
export default node;
